import {
  getAmenitiesByGroupId,
  updateAmenityByGroupId,
} from "../../../../Redux/Groups/GroupsActions";
import processTermsAndCondition from "../../../../Util/processTermsAndCondition";
import { IoCheckmarkCircle, IoClose, IoCloseCircle } from "react-icons/io5";
import validator, { ValidationField } from "../../../../Util/validator";
import { AppDispatch, RootState } from "../../../../Redux/store";
import imageUrlHelper from "../../../../Util/imageUrlHelper";
import imageToBase64 from "../../../../Util/imageToBase64";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import styles from "./EditAmenity.module.scss";
import { CiImageOn } from "react-icons/ci";
import Editor from "react-simple-wysiwyg";

interface DoorEntry {
  doorName: string;
  doorId: string;
  panelId: string;
}

interface ParkingEntry {
  parkingName: string;
}

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string;
  amenityData: any;
}

function EditAmenity(props: Props) {
  const { setIsOpen, groupId, amenityData } = props;
  const ref = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const {
    getAllAmenityTypesData,
    getAllAmenitiesRateTypesData,
    updateAmenityByGroupIdLoading,
  } = useSelector((state: RootState) => state.groups);

  const { getBuildingsByGroupIdList } = useSelector(
    (state: RootState) => state.buildings,
  );

  const [name, setName] = useState("");
  const [amenityTypeId, setAmenityTypeId] = useState("");
  const [rates, setRates] = useState("");
  const [rateTypeId, setRateTypeId] = useState("");
  const [rule, setRule] = useState("");
  const [lockId, setLockId] = useState("");
  const [image, setImage] = useState<File | string | null>(null);
  const [isActive, setIsActive] = useState("true");
  const [requiredBooking, setRequiredBooking] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [doorName, setDoorName] = useState("");
  const [isGuest, setIsGuest] = useState(false);
  const [refundPercentage, setRefundPercentage] = useState("");
  const [doorId, setDoorId] = useState("");
  const [buildingId, setBuildingId] = useState("");
  const [panelId, setPanelId] = useState("");
  const [doors, setDoors] = useState<DoorEntry[]>([]);
  const [parkingName, setParkingName] = useState("");
  const [parkings, setParkings] = useState<ParkingEntry[]>([]);
  const [isParkingTypeSelected, setIsParkingTypeSelected] = useState(false);
  const [isAddOnTypeSelected, setIsAddOnTypeSelected] = useState(false);
  const [noOfVehicle, setNoOfVehicle] = useState("");
  const [isBookable, setIsBookable] = useState(false);
  const [maxHours, setMaxHours] = useState("");
  const [parkingChart, setParkingChart] = useState<File | string | null>(null);
  const parkingChartRef = useRef<HTMLInputElement>(null);
  const [errors, setErrors] = useState<{
    name: string;
    amenityTypeId: string;
    rates: string;
    rateTypeId: string;
    rule: string;
    lockId: string;
    isActive: string;
    image: string;
    termsAndConditions: string;
    doorName: string;
    buildingId: string;
    refundPercentage: string;
    isGuest: boolean;
    doorId: string;
    panelId: string;
    doors: string;
    parkingName: string;
    parkings: string;
    noOfVehicle: string;
    noOfQuantity: string;
    isBookable: boolean;
    maxHours: string;
    parkingChart: string;
  }>({
    name: "",
    amenityTypeId: "",
    rates: "",
    rateTypeId: "",
    rule: "",
    lockId: "",
    isActive: "",
    image: "",
    termsAndConditions: "",
    doorName: "",
    buildingId: "",
    refundPercentage: "",
    isGuest: false,
    doorId: "",
    panelId: "",
    doors: "",
    parkingName: "",
    parkings: "",
    noOfVehicle: "",
    noOfQuantity: "",
    isBookable: false,
    maxHours: "",
    parkingChart: "",
  });

  const addDoorHandler = () => {
    const { errors: doorErrors, isValid } = validator([
      { key: "doorName", value: doorName, type: "text" },
    ]);

    setErrors((prev) => ({
      ...prev,
      doorName: doorErrors.doorName || "",
      doorId: "",
      panelId: "",
      doors: "",
    }));

    if (!isValid) return;

    setDoors((prev) => [
      ...prev,
      {
        doorName: doorName.trim(),
        doorId: doorId || "0",
        panelId: panelId || "0",
      },
    ]);
    setDoorName("");
    setDoorId("");
    setPanelId("");
    setErrors((prev) => ({
      ...prev,
      doorName: "",
      doorId: "",
      panelId: "",
      doors: "",
    }));
  };

  const removeDoorHandler = (index: number) => {
    setDoors((prev) => prev.filter((_, i) => i !== index));
  };

  const addParkingHandler = () => {
    const { errors: parkingErrors, isValid } = validator([
      { key: "parkingName", value: parkingName, type: "text" },
    ]);

    setErrors((prev) => ({
      ...prev,
      parkingName: parkingErrors.parkingName || "",
      parkings: "",
    }));

    if (!isValid) return;

    setParkings((prev) => [
      ...prev,
      {
        parkingName: parkingName.trim(),
      },
    ]);
    setParkingName("");
    setErrors((prev) => ({
      ...prev,
      parkingName: "",
      parkings: "",
    }));
  };

  const removeParkingHandler = (index: number) => {
    setParkings((prev) => prev.filter((_, i) => i !== index));
  };

  const updateAmenityHandler = async () => {
    let fieldsArray: ValidationField[] = [
      {
        key: "name",
        value: name,
        type: "text",
      },
      {
        key: "amenityTypeId",
        value: amenityTypeId,
        type: "text",
      },
      {
        key: "rule",
        value: rule,
        type: "text",
      },
      {
        key: "lockId",
        value: lockId,
        type: "text",
      },
      {
        key: "isActive",
        value: isActive,
        type: "text",
      },
      {
        key: "image",
        value: image,
        type: "file",
      },
      {
        key: "buildingId",
        value: buildingId,
        type: "text",
      },
      {
        key: "rates",
        value: rates,
        type: "text",
      },
    ];

    if (isParkingTypeSelected) {
      fieldsArray.push(
        {
          key: "parkingChart",
          value: parkingChart,
          type: "file",
        },
        {
          key: "termsAndConditions",
          value: termsAndConditions,
          type: "editor",
        },
      );
    } else {
      fieldsArray.push(
        {
          key: "rateTypeId",
          value: rateTypeId,
          type: "text",
        },
        {
          key: "isGuest",
          value: isGuest.toString(),
          type: "text",
        },
        {
          key: "isBookable",
          value: isBookable.toString(),
          type: "text",
        },
      );

      if (isBookable) {
        fieldsArray.push({
          key: "maxHours",
          value: maxHours,
          type: "text",
        });
      }

      if (requiredBooking) {
        fieldsArray.push({
          key: "refundPercentage",
          value: refundPercentage,
          type: "numberOnly",
          range: "1-100",
        });
      }

      if (isAddOnTypeSelected) {
        fieldsArray.push({
          key: "noOfVehicle",
          value: noOfVehicle,
          type: "numberOnly",
        });
      }

      if (requiredBooking || isAddOnTypeSelected) {
        fieldsArray.push({
          key: "termsAndConditions",
          value: termsAndConditions,
          type: "editor",
        });
      }
    }

    const { errors: fieldsErrors, isValid } = validator(fieldsArray);
    const doorsError = doors.length === 0 ? "Please add at least one door" : "";
    const parkingsError =
      isParkingTypeSelected && parkings.length === 0
        ? "Please add at least one parking slot"
        : "";

    setErrors({
      ...errors,
      ...fieldsErrors,
      doors: doorsError,
      parkings: parkingsError,
    });
    if (isValid && !doorsError && !parkingsError) {
      if (!updateAmenityByGroupIdLoading && groupId) {
        const successHandler = () => {
          setIsOpen(false);
          dispatch(
            getAmenitiesByGroupId({
              groupId: groupId,
            }),
          );
        };
        const imagebase64 = await imageToBase64(image);
        const parkingChartbase64 = await imageToBase64(parkingChart);
        dispatch(
          updateAmenityByGroupId({
            amenityId: amenityData?.amenityId,
            groupId: groupId,
            name: name,
            amenityTypeId: amenityTypeId,
            rates: rates,
            cost: rates,
            rateTypeId: isParkingTypeSelected ? "0" : rateTypeId || "1",
            rule: rule,
            lockId: lockId,
            image: imagebase64,
            isActive: isActive === "true" ? true : false,
            requiresBooking: isParkingTypeSelected ? false : requiredBooking,
            terms: processTermsAndCondition(termsAndConditions),
            doors: doors,
            parkings: isParkingTypeSelected ? parkings : [],
            nonRefundPercent: isParkingTypeSelected
              ? "0"
              : refundPercentage || "0",
            isGuest: isParkingTypeSelected ? false : isGuest,
            isBookableSlot: isParkingTypeSelected ? false : isBookable,
            noOfVehicle: isParkingTypeSelected ? "1" : noOfVehicle || "1",
            buildingId: buildingId,
            maxHours: isParkingTypeSelected ? "1" : maxHours || "1",
            parkingImage: isParkingTypeSelected ? parkingChartbase64 : "",
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    if (amenityData) {
      setName(amenityData?.name);
      setAmenityTypeId(amenityData?.amenityTypeId);
      setRateTypeId(amenityData?.rateTypeId);
      setLockId(amenityData?.lockId);
      setRates(amenityData?.rate?.toString());
      setRule(amenityData?.rules);
      setIsActive(amenityData?.status === "Active" ? "true" : "false");
      setRequiredBooking(amenityData?.requiresBooking);
      setImage(amenityData?.image);
      setTermsAndConditions(amenityData?.terms);
      const existingDoors = Array.isArray(amenityData?.doors)
        ? amenityData.doors.map((door: any) => ({
            doorName: door?.doorName || "",
            doorId: String(door?.doorId ?? door?.doorid ?? "0"),
            panelId: String(door?.panelId ?? door?.panelid ?? "0"),
          }))
        : amenityData?.doorName
          ? [
              {
                doorName: amenityData.doorName,
                doorId: String(
                  amenityData?.doorId ?? amenityData?.doorid ?? "0",
                ),
                panelId: String(
                  amenityData?.panelId ?? amenityData?.panelid ?? "0",
                ),
              },
            ]
          : [];
      setDoors(existingDoors);
      setDoorName("");
      setDoorId("");
      setPanelId("");
      const existingParkings = Array.isArray(amenityData?.parkings)
        ? amenityData.parkings.map((parking: any) => ({
            parkingName: parking?.parkingName || "",
          }))
        : amenityData?.parkingName
          ? [{ parkingName: amenityData.parkingName }]
          : [];
      setParkings(existingParkings);
      setParkingName("");
      setRefundPercentage(amenityData?.nonRefundPercent?.toString());
      setIsGuest(amenityData?.isGuest?.toString() === "true");
      setNoOfVehicle(amenityData?.noofvehicle?.toString() ?? "");
      setIsBookable(amenityData?.isBookableSlot?.toString() === "true");
      setMaxHours(amenityData?.maxhours?.toString() ?? "");
      setParkingChart(amenityData?.parkingImage);
      setBuildingId(
        amenityData?.buildingId && amenityData.buildingId !== 0
          ? amenityData.buildingId.toString()
          : "",
      );
    }
  }, [amenityData]);

  useEffect(() => {
    const amenityType = getAllAmenityTypesData?.find(
      // eslint-disable-next-line eqeqeq
      (type) => type?.amenityTypeId == amenityTypeId,
    );
    setIsParkingTypeSelected(
      amenityType?.amenityTypeName?.toLowerCase() === "parking",
    );
    setIsAddOnTypeSelected(
      amenityType?.amenityTypeName?.toLowerCase() === "addon",
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amenityTypeId]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Edit Amenity</h1>
      </div>
      <form className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Amenity Title</p>
          <input
            type="text"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <p className={styles.error}>{errors.name}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Type</p>
            <select
              className={styles.input}
              value={amenityTypeId}
              onChange={(e) => setAmenityTypeId(e.target.value)}
            >
              <option value="">Select Type</option>
              {getAllAmenityTypesData?.map((type, i: number) => (
                <option key={i} value={type?.amenityTypeId}>
                  {type?.amenityTypeName}
                </option>
              ))}
            </select>
            <p className={styles.error}>{errors.amenityTypeId}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Lock ID</p>
            <input
              type="text"
              className={styles.input}
              value={lockId}
              onChange={(e) => setLockId(e.target.value)}
            />
            <p className={styles.error}>{errors.lockId}</p>
          </div>
        </div>
        <div className={styles.textAreaContainer}>
          <p className={styles.label}>Description/Rules</p>
          <textarea
            className={styles.textArea}
            value={rule}
            onChange={(e) => setRule(e.target.value)}
            rows={4}
          />
          <p className={styles.error}>{errors.rule}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Status</p>
          <select
            className={styles.input}
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value={"true"}>Active</option>
            <option value={"false"}>Inactive</option>
          </select>
          <p className={styles.error}>{errors.isActive}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Building</p>
          <select
            className={styles.input}
            value={buildingId}
            onChange={(e) => setBuildingId(e.target.value)}
          >
            {!buildingId && <option value="">Select Building</option>}
            {getBuildingsByGroupIdList?.map((building: any, i: number) => (
              <option key={i} value={building?.buildingId}>
                {building?.buildingName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.buildingId}</p>
        </div>
        {!isParkingTypeSelected && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Is Guest</p>
            <select
              className={styles.input}
              value={isGuest.toString()}
              onChange={(e) =>
                setIsGuest(e.target.value === "true" ? true : false)
              }
            >
              <option value={"true"}>True</option>
              <option value={"false"}>False</option>
            </select>
            <p className={styles.error}>{errors.isGuest}</p>
          </div>
        )}

        {!isParkingTypeSelected && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Bookable</p>
            <select
              className={styles.input}
              value={isBookable.toString()}
              onChange={(e) =>
                setIsBookable(e.target.value === "true" ? true : false)
              }
            >
              <option value={"true"}>True</option>
              <option value={"false"}>False</option>
            </select>
            <p className={styles.error}>{errors.isBookable}</p>
          </div>
        )}
        {isBookable && !isParkingTypeSelected && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Max hours</p>
            <input
              type="text"
              className={styles.input}
              value={maxHours}
              onChange={(e) => setMaxHours(e.target.value)}
            />
            <p className={styles.error}>{errors.maxHours}</p>
          </div>
        )}
        {!isParkingTypeSelected && (
          <div className={styles.doubleInputContainer}>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Rate Type</p>
              <select
                className={styles.input}
                value={rateTypeId}
                onChange={(e) => setRateTypeId(e.target.value)}
              >
                <option value="">Select Rate Type</option>
                {getAllAmenitiesRateTypesData?.map((type, i: number) => (
                  <option key={i} value={type?.rateTypeId}>
                    {type?.rateTypeName}
                  </option>
                ))}
              </select>
              <p className={styles.error}>{errors.rateTypeId}</p>
            </div>
          </div>
        )}
        <div className={styles.doorsSection}>
          <p className={styles.sectionLabel}>Doors</p>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Door Name</p>
            <input
              type="text"
              className={styles.input}
              value={doorName}
              onChange={(e) => setDoorName(e.target.value)}
            />
            <p className={styles.error}>{errors.doorName}</p>
          </div>
          <div className={styles.doubleInputContainer}>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Door ID</p>
              <input
                type="text"
                className={styles.input}
                value={doorId}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setDoorId(e.target.value);
                  }
                }}
              />
              <p className={styles.error}>{errors.doorId}</p>
            </div>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Panel ID</p>
              <input
                type="text"
                className={styles.input}
                value={panelId}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setPanelId(e.target.value);
                  }
                }}
              />
              <p className={styles.error}>{errors.panelId}</p>
            </div>
          </div>
          <button
            type="button"
            className={styles.addDoorBtn}
            onClick={addDoorHandler}
          >
            Add Door
          </button>
          {doors.length > 0 && (
            <div className={styles.doorsList}>
              {doors.map((door, index) => (
                <div key={index} className={styles.doorItem}>
                  <div className={styles.doorInfo}>
                    <p className={styles.doorTitle}>{door.doorName}</p>
                    <p className={styles.doorMeta}>
                      Door ID: {door.doorId} · Panel ID: {door.panelId}
                    </p>
                  </div>
                  <IoClose
                    className={styles.removeDoorIcon}
                    onClick={() => removeDoorHandler(index)}
                  />
                </div>
              ))}
            </div>
          )}
          <p className={styles.error}>{errors.doors}</p>
        </div>
        {isParkingTypeSelected && (
          <div className={styles.doorsSection}>
            <p className={styles.sectionLabel}>Parking Slots</p>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Parking Slot Name</p>
              <input
                type="text"
                className={styles.input}
                value={parkingName}
                onChange={(e) => setParkingName(e.target.value)}
              />
              <p className={styles.error}>{errors.parkingName}</p>
            </div>
            <button
              type="button"
              className={styles.addDoorBtn}
              onClick={addParkingHandler}
            >
              Add Parking Slot
            </button>
            {parkings.length > 0 && (
              <div className={styles.doorsList}>
                {parkings.map((parking, index) => (
                  <div key={index} className={styles.doorItem}>
                    <div className={styles.doorInfo}>
                      <p className={styles.doorTitle}>{parking.parkingName}</p>
                    </div>
                    <IoClose
                      className={styles.removeDoorIcon}
                      onClick={() => removeParkingHandler(index)}
                    />
                  </div>
                ))}
              </div>
            )}
            <p className={styles.error}>{errors.parkings}</p>
          </div>
        )}
        <div className={styles.priceInputContainer}>
          <p className={styles.label}>Rates</p>
          <div className={styles.inputContainer}>
            <p className={styles.currency}>$</p>
            <input
              type="text"
              className={styles.input}
              value={rates}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(value)) {
                  setRates(value);
                }
              }}
            />
          </div>
          <p className={styles.error}>{errors.rates}</p>
        </div>

        {isParkingTypeSelected && (
          <div className={styles.imageInputContainer}>
            <p className={styles.label}>Parking Chart</p>
            <input
              className={styles.imageInput}
              type="file"
              hidden
              ref={parkingChartRef}
              accept="image/*"
              value={""}
              onChange={(e) => setParkingChart(e.target.files?.[0] || null)}
            />
            {parkingChart ? (
              <div className={styles.inputImageContainer}>
                <img
                  className={styles.inputImage}
                  src={imageUrlHelper(parkingChart)}
                  alt="Building"
                />
                <div className={styles.iconContainer}>
                  <IoClose
                    className={styles.icon}
                    onClick={() => setParkingChart(null)}
                  />
                </div>
              </div>
            ) : (
              <div
                className={styles.imageInputBox}
                onClick={() => parkingChartRef.current?.click()}
              >
                <div className={styles.iconContainer}>
                  <CiImageOn className={styles.icon} />
                </div>
                <div className={styles.labelContainer}>
                  <p className={styles.label}>Upload Image</p>
                </div>
              </div>
            )}
            <p className={styles.error}>{errors.parkingChart}</p>
          </div>
        )}

        {isAddOnTypeSelected && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>No of Units</p>
            <input
              type="text"
              className={styles.input}
              value={noOfVehicle}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setNoOfVehicle(e.target.value);
                }
              }}
            />
            <p className={styles.error}>{errors.noOfVehicle}</p>
          </div>
        )}
        {requiredBooking && !isParkingTypeSelected && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Non-Refund Percentage</p>
            <input
              type="text"
              className={styles.input}
              value={refundPercentage}
              onChange={(e) => setRefundPercentage(e.target.value)}
            />
            <p className={styles.error}>{errors.refundPercentage}</p>
          </div>
        )}
        {!isParkingTypeSelected && (
          <div className={styles.requiredBookingContainer}>
            <div
              className={styles.requiredBookingIconContainer}
              onClick={() => setRequiredBooking(!requiredBooking)}
            >
              {requiredBooking ? (
                <IoCheckmarkCircle
                  className={styles.iconNotRequiredBooking}
                  size={20}
                />
              ) : (
                <IoCloseCircle className={styles.iconRequiredBooking} size={20} />
              )}
            </div>
            <div className={styles.requiredBookingLabelContainer}>
              <p className={styles.label}>Required Booking?</p>
            </div>
          </div>
        )}
        {(requiredBooking || isParkingTypeSelected || isAddOnTypeSelected) && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Terms and Conditions</p>
            <Editor
              className={styles.termsInput}
              value={termsAndConditions}
              onChange={(e) => setTermsAndConditions(e.target.value)}
            />
            <p className={styles.error}>{errors.termsAndConditions}</p>
          </div>
        )}
        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Amenity Image</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={ref}
            accept="image/*"
            value={""}
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {image ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(image)}
                alt="Building"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setImage(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => ref.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
          <p className={styles.error}>{errors.image}</p>
        </div>

        {updateAmenityByGroupIdLoading && <Loading />}
      </form>

      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={updateAmenityHandler}>
          Update
        </button>
        <button className={styles.cancelBtn} onClick={() => setIsOpen(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default EditAmenity;
